var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 150,
    viewBox: "0 0 130 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 65,
    cy: 68.8889,
    r: 18,
    fill: "#2BC97C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65 25C65 25 66.8246 47.1299 67.1672 64.2984C77.0509 54.9851 90.1878 44.303 90.1878 44.303C90.1878 44.303 79.5292 57.4111 70.2231 67.2911C85.5865 67.666 105 69.4444 105 69.4444C105 69.4444 85.5482 71.2264 70.1777 71.5989C79.4836 81.4788 90.1416 94.5861 90.1416 94.5861C90.1416 94.5861 77.0448 83.9366 67.1663 74.6334C66.8216 91.7958 65 113.889 65 113.889C65 113.889 63.1815 91.8325 62.8346 74.6762C52.9614 83.9693 39.9047 94.5862 39.9047 94.5862C39.9047 94.5862 50.5619 81.4798 59.8675 71.6C44.49 71.2299 25 69.4444 25 69.4444C25 69.4444 44.4517 67.6625 59.8221 67.29C50.5163 57.4101 39.8584 44.3029 39.8584 44.3029C39.8584 44.3029 52.9552 54.9524 62.8337 64.2556C63.1784 47.0932 65 25 65 25Z",
    fill: "url(#paint0_radial_102_33)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_33",
    x: 0,
    y: 0,
    width: 130,
    height: 138.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425 0 0 0 0 1 0 0 0 0 0.375 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_33"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_33",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_102_33",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65 67.7778) rotate(57.4396) scale(54.7102 42.327)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BC97C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BC97C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.23aa1f59c98f157d9b29973e98406125.svg";
export { ForwardRef as ReactComponent };